import { useEffect, useState, memo, useRef } from 'react';
import KnowledgePointsContent from '@/containers/qa-drawer/components/knowledge-points-drawer/knowledge-points-content';
import { getGlobalStore } from '@/store/global';
import DragDrawer from '@/components/drag-drawer';

const KnowledgeSliceRightDrawer = () => {
    const callbacksRef = useRef<Record<string, () => void>>();
    const [collectRecordId, setCollectRecordId] = useState<string>();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [visible, setVisible] = useState(false);

    const handleCloseDrawer = () => {
        callbacksRef.current?.onClose();
        setVisible(false);
        setCollectRecordId(undefined);
        setTimeout(() => setContent(''), 500);
    };

    useEffect(() => {
        getGlobalStore()?.subscribe(
            'KnowledgePointsRightDrawer',
            (params: { type: string; title: string; content: string; recordId: string; callbacks: Record<string, () => void> }) => {
                switch (params.type) {
                    case 'show':
                        callbacksRef.current = params.callbacks;
                        setCollectRecordId(params.recordId);
                        setTitle(params.title);
                        setContent(params.content);
                        setVisible(true);
                        break;
                    default:
                        handleCloseDrawer();
                        break;
                }
            }
        );
    }, []);

    return (
        <DragDrawer width={375} open={visible} onClose={handleCloseDrawer}>
            <KnowledgePointsContent collectRecordId={collectRecordId} title={title} content={content} onClose={handleCloseDrawer} />
        </DragDrawer>
    );
};

export default memo(KnowledgeSliceRightDrawer);
